import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Bell from "core/ReusableIcons/Bell";

// data
import { trackheaderMarketingClicked } from "core/trackEvent";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { textMd } from "core/fontStyles";
import colors, { focusStyles } from "core/colors";

const MarketingMessageStyled = styled.div`
    margin-top: ${convertPxToRem(16)};
    display: flex;
    gap: ${convertPxToRem(6)};
`;

const BellWrapperStyled = styled.div`
    flex: 0 0 14px;

    svg {
        position: relative;
        top: ${convertPxToRem(6)};
    }
`;

export const MarketingMessageTextStyled = styled.div`
    flex: 1;
    text-align: left;
    ${textMd}
    color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.primary.diamond : colors.secondary.orca};

    a {
        text-decoration: none;
        padding-bottom: ${convertPxToRem(4)};

        border-bottom-style: solid;
        border-bottom-width: ${convertPxToRem(1)};
        border-bottom-color: ${({ $isDarkMode }) =>
            $isDarkMode
                ? colors.accent.darkMode.suenosBuenos
                : colors.accent.lightMode.persian};

        color: ${({ $isDarkMode }) =>
            $isDarkMode
                ? colors.accent.darkMode.suenosBuenos
                : colors.accent.lightMode.persian};


        &:hover {
            color: ${({ $isDarkMode }) =>
                $isDarkMode
                    ? colors.accent.darkMode.surf
                    : colors.accent.lightMode.pansy};
            border-bottom-color: ${({ $isDarkMode }) =>
                $isDarkMode
                    ? colors.accent.darkMode.surf
                    : colors.accent.lightMode.pansy};

        }

        ${focusStyles}
    }
`;

// component
export const MarketingMessage = ({ className }) => {
    const {
        isDarkMode,
        marketingMessage: { html, hideBell }
    } = useSiteHeader();

    if (!html) return null;

    return (
        <MarketingMessageStyled className={className}>
            {!hideBell && (
                <BellWrapperStyled data-testid="marketing-message-has-bell">
                    <Bell
                        fillColor={colors.functional.lightMode.gladiola}
                        size={{ width: 14, height: 14 }}
                    />
                </BellWrapperStyled>
            )}

            <MarketingMessageTextStyled
                onMouseDown={trackheaderMarketingClicked}
                $isDarkMode={isDarkMode}
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </MarketingMessageStyled>
    );
};

export default MarketingMessage;

// prop-types
MarketingMessage.propTypes = {
    className: PropTypes.string
};
